import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _mean from "lodash/mean";
import "core-js/modules/es6.array.fill.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.weak-map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { AsyncGzip } from 'fflate';
import filereaderStream from 'filereader-stream';
import PartUploader from 'utils/upload/FileUploader/PartUploader';
import FileUploaderError from 'utils/errors/upload/FileUploaderError';
import fetchAPI from 'utils/http/fetchAPI';
import NotImplementedError from 'utils/errors/NotImplementedError';
import UploadStatus from '../UploadStatus';
var _subscribeToAbortSignal = /*#__PURE__*/new WeakMap();
var _getUploadedParts = /*#__PURE__*/new WeakMap();
var _setupGzipStreamHandlers = /*#__PURE__*/new WeakMap();
var _setupReadStreamHandlers = /*#__PURE__*/new WeakMap();
var _abortUpload = /*#__PURE__*/new WeakMap();
var _cleanupExecution = /*#__PURE__*/new WeakMap();
var _handleChunkLoadFinished = /*#__PURE__*/new WeakMap();
var _createOnUploadProgress = /*#__PURE__*/new WeakMap();
var _reserveUploadSlot = /*#__PURE__*/new WeakMap();
var _releaseUploadSlot = /*#__PURE__*/new WeakMap();
var FileUploader = /*#__PURE__*/function () {
  function FileUploader(file, chunkSize, uploadParams, abortController, onStatusUpdate, options) {
    var _this = this;
    _classCallCheck(this, FileUploader);
    _classPrivateFieldInitSpec(this, _subscribeToAbortSignal, function () {
      _this.abortController.signal.addEventListener('abort', function (reason) {
        return _classPrivateFieldGet(_cleanupExecution, _this).call(_this, reason);
      });
    });
    _classPrivateFieldInitSpec(this, _getUploadedParts, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$uploadParams, projectId, uploadId, bucket, key, url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$uploadParams = _this.uploadParams, projectId = _this$uploadParams.projectId, uploadId = _this$uploadParams.uploadId, bucket = _this$uploadParams.bucket, key = _this$uploadParams.key;
            url = "/v2/projects/".concat(projectId, "/upload/").concat(uploadId, "/getUploadedParts");
            _context.next = 4;
            return fetchAPI(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                bucket: bucket,
                key: key
              })
            });
          case 4:
            return _context.abrupt("return", _context.sent);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _classPrivateFieldInitSpec(this, _setupGzipStreamHandlers, function () {
      _this.gzipStream.ondata = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(err, chunk) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                if (!err) {
                  _context2.next = 3;
                  break;
                }
                throw new Error(err);
              case 3:
                _context2.next = 5;
                return _classPrivateFieldGet(_handleChunkLoadFinished, _this).call(_this, chunk);
              case 5:
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                _classPrivateFieldGet(_abortUpload, _this).call(_this, _context2.t0);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 7]]);
        }));
        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }();
    });
    _classPrivateFieldInitSpec(this, _setupReadStreamHandlers, function () {
      _this.readStream.on('data', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chunk) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _classPrivateFieldGet(_reserveUploadSlot, _this).call(_this);
              case 3:
                if (_this.compress) {
                  _context3.next = 7;
                  break;
                }
                _context3.next = 6;
                return _classPrivateFieldGet(_handleChunkLoadFinished, _this).call(_this, chunk);
              case 6:
                return _context3.abrupt("return");
              case 7:
                // This is necessary to connect the streams between read and compress.
                // gzipStream needs to know which is the last chunk when it is being pushed
                // but normal streams don't have a way of knowing that in the 'data' event
                // So we need to push the last chunk in the 'end' event.
                if (_this.currentChunk !== null) _this.gzipStream.push(_this.currentChunk);
                _this.currentChunk = chunk;
                _context3.next = 14;
                break;
              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);
                _classPrivateFieldGet(_abortUpload, _this).call(_this, _context3.t0);
              case 14:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[0, 11]]);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
      _this.readStream.on('error', function (e) {
        _classPrivateFieldGet(_abortUpload, _this).call(_this, e);
      });
      _this.readStream.on('end', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (_this.compress) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _context4.next = 5;
              return _classPrivateFieldGet(_reserveUploadSlot, _this).call(_this);
            case 5:
              _this.gzipStream.push(_this.currentChunk, true);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              _classPrivateFieldGet(_abortUpload, _this).call(_this, _context4.t0);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 8]]);
      })));
    });
    _classPrivateFieldInitSpec(this, _abortUpload, function (e) {
      var _this$abortController;
      (_this$abortController = _this.abortController) === null || _this$abortController === void 0 || _this$abortController.abort(e.message);
      console.error(e);
    });
    _classPrivateFieldInitSpec(this, _cleanupExecution, function (reason) {
      var _this$readStream, _this$gzipStream;
      (_this$readStream = _this.readStream) === null || _this$readStream === void 0 || _this$readStream.destroy();
      (_this$gzipStream = _this.gzipStream) === null || _this$gzipStream === void 0 || _this$gzipStream.terminate();
      var reasonMessage = reason === null || reason === void 0 ? void 0 : reason.target.reason;
      _this.reject(new FileUploaderError(reasonMessage));
    });
    _classPrivateFieldInitSpec(this, _handleChunkLoadFinished, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(chunk) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return navigator.locks.request(_this.handleChunkLoadFinished, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var onUploadProgress, uploadedParts;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;
                      _this.chunkNumberIt += 1;
                      onUploadProgress = _classPrivateFieldGet(_createOnUploadProgress, _this).call(_this, _this.chunkNumberIt);
                      _context5.next = 5;
                      return _this.partUploader.uploadChunk(chunk, onUploadProgress);
                    case 5:
                      // To track when all chunks have been uploaded
                      _this.pendingChunks -= 1;
                      if (!(_this.pendingChunks > 0)) {
                        _context5.next = 9;
                        break;
                      }
                      _context5.next = 9;
                      return _classPrivateFieldGet(_releaseUploadSlot, _this).call(_this);
                    case 9:
                      if (!(_this.pendingChunks === 0)) {
                        _context5.next = 14;
                        break;
                      }
                      _context5.next = 12;
                      return _this.partUploader.finishUpload();
                    case 12:
                      uploadedParts = _context5.sent;
                      _this.resolve(uploadedParts);
                    case 14:
                      _context5.next = 19;
                      break;
                    case 16:
                      _context5.prev = 16;
                      _context5.t0 = _context5["catch"](0);
                      _classPrivateFieldGet(_abortUpload, _this).call(_this, _context5.t0);
                    case 19:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5, null, [[0, 16]]);
              })));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "chunkNumbersDebug", []);
    _classPrivateFieldInitSpec(this, _createOnUploadProgress, function (chunkNumber) {
      return function (progress) {
        _this.chunkNumbersDebug.push(chunkNumber);
        // partNumbers are 1-indexed, so we need to subtract 1 for the array index
        _this.uploadedPartPercentages[chunkNumber - 1] = progress.progress;
        var percentage = (_mean(_this.uploadedPartPercentages) * 100).toFixed(2);
        _this.onStatusUpdate(UploadStatus.UPLOADING, percentage);
      };
    });
    _classPrivateFieldInitSpec(this, _reserveUploadSlot, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return navigator.locks.request(_this.freeUploadSlotsLock, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _this.freeUploadSlots -= 1;
                    if (_this.freeUploadSlots <= 0) {
                      // We need to wait for some uploads to finish before we can continue
                      _this.readStream.pause();
                    }
                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            })));
          case 2:
            return _context8.abrupt("return", _context8.sent);
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    })));
    _classPrivateFieldInitSpec(this, _releaseUploadSlot, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
      return _regeneratorRuntime.wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            _context0.next = 2;
            return navigator.locks.request(_this.freeUploadSlotsLock, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
              return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _this.freeUploadSlots += 1;
                    _this.readStream.resume();
                  case 2:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9);
            })));
          case 2:
            return _context0.abrupt("return", _context0.sent);
          case 3:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    })));
    if (!file || !chunkSize || !uploadParams || !abortController || !onStatusUpdate) {
      throw new Error('FileUploader: Missing required parameters');
    }
    var resumeUpload = options.resumeUpload,
      compress = options.compress,
      _options$retryPolicy = options.retryPolicy,
      retryPolicy = _options$retryPolicy === void 0 ? 'normal' : _options$retryPolicy;
    if (resumeUpload && compress) {
      // This should be fine for our current use cases:
      // 1 - Secondary analysis: Resumable non-compressing uploads
      // 2 - Tertiary analysis: Compressing non-resumable uploads
      throw new NotImplementedError('Resumable and compressing uploads at the same time is not implemented yet');
    }
    this.file = file;
    this.compress = compress;
    this.chunkSize = chunkSize;
    this.uploadParams = uploadParams;
    this.resumeUpload = resumeUpload;
    this.retryPolicy = retryPolicy;

    // Upload related callbacks and handling
    this.onStatusUpdate = onStatusUpdate;
    this.abortController = abortController;

    // Stream handling
    this.totalChunks = Math.ceil(file.size / chunkSize);
    this.pendingChunks = this.totalChunks;

    // Locks to control the number of simultaneous uploads to avoid taking up too much ram
    this.freeUploadSlotsLock = "freeUploadSlots".concat(this.uploadParams.uploadId);
    this.freeUploadSlots = 3;
    this.handleChunkLoadFinished = "handleChunkLoadFinished".concat(this.uploadParams.uploadId);

    // Used to track chunk numbers when filling the progress bar
    this.chunkNumberIt = 0;
    this.readStream = null;
    this.gzipStream = null;
    this.resolve = null;
    this.reject = null;

    // To track upload progress
    this.uploadedPartPercentages = new Array(this.totalChunks).fill(0);
    this.currentChunk = null;
    _classPrivateFieldGet(_subscribeToAbortSignal, this).call(this);
  }
  _createClass(FileUploader, [{
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
        var _this2 = this;
        var offset, uploadedParts, nextPartNumber, i;
        return _regeneratorRuntime.wrap(function _callee1$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              offset = 0;
              uploadedParts = [];
              if (!this.resumeUpload) {
                _context1.next = 13;
                break;
              }
              _context1.next = 5;
              return _classPrivateFieldGet(_getUploadedParts, this).call(this);
            case 5:
              uploadedParts = _context1.sent;
              if (!(uploadedParts.length === this.totalChunks)) {
                _context1.next = 8;
                break;
              }
              return _context1.abrupt("return", uploadedParts);
            case 8:
              nextPartNumber = uploadedParts.length + 1; // setting all previous parts as uploaded
              // this.uploadedPartPercentages.fill(1, 0, nextPartNumber - 1);
              for (i = 0; i < nextPartNumber - 1; i += 1) {
                this.uploadedPartPercentages[i] = 1;
              }
              this.chunkNumberIt = nextPartNumber - 1;
              offset = this.chunkNumberIt * this.chunkSize;
              this.pendingChunks = this.totalChunks - nextPartNumber + 1;
            case 13:
              this.partUploader = new PartUploader(this.uploadParams, this.abortController, this.file.size, uploadedParts);
              return _context1.abrupt("return", new Promise(function (resolve, reject) {
                var _this2$file;
                _this2.resolve = resolve;
                _this2.reject = reject;
                _this2.readStream = filereaderStream(((_this2$file = _this2.file) === null || _this2$file === void 0 ? void 0 : _this2$file.fileObject) || _this2.file, {
                  chunkSize: _this2.chunkSize,
                  offset: offset
                });
                _classPrivateFieldGet(_setupReadStreamHandlers, _this2).call(_this2);
                if (_this2.compress) {
                  _this2.gzipStream = new AsyncGzip({
                    level: 1,
                    consume: true
                  });
                  _classPrivateFieldGet(_setupGzipStreamHandlers, _this2).call(_this2);
                }
              }));
            case 15:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function upload() {
        return _upload.apply(this, arguments);
      }
      return upload;
    }()
  }]);
  return FileUploader;
}();
export default FileUploader;